function getContacts (planning) {
  return planning?.werk?.contacts || []
}

export default getContacts
